import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../features/authSlice";
import userReducer from "../features/userSlice";
import sidebarReducer from "./sidebarSlice";
import adminSidebar from "./adminSidebarSlice";

// 🔹 redux-persist config
const persistConfig = {
  key: "admin_root",
  storage,
  whitelist: ["sidebar", "adminSidebar"],
};

// 🔹 Combine all reducers here
const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  sidebar: sidebarReducer,
    adminSidebar: adminSidebar,
});

// 🔹 Wrap rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 🔹 Configure Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// 🔹 Create persistor
export const persistor = persistStore(store);
